<template>
    <div>
        <CCol sm="12">
            <div style="width:50%;padding:20px;padding-top:30px" class="text-left">
                <img style="max-width: 40px;" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            </div>
            <CRow class="m-0 justify-content-center align-items-center">
                <img style="max-width:100%" src="../assets/img/iconmap.png" />
                <h3 class="custom-header-location mt-4">
                    Choose Location
                </h3>
                <p class="custom-12px text-center">Kindly allow us to access your location to provide you <br /> with suggestions for nearby salons</p>
               <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                <CRow>
                    <div style="width:90%">
                        <h3 class="custom-14px-500 text-left">Current Location</h3>
                    </div>
                    <div style="width:10%">
                    <input type="radio" class="mt-2"/></div>

                    <div style="width:90%">
                        <h3 class="custom-14px-500 text-left">Different Location</h3>
                    </div>
                    <div style="width:10%">
                    <input type="radio" class="mt-2"/></div>
                    <div style="width:100%; margin: 0 auto">
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToDate()">Continue</CButton>
                </div>
                </CRow>
               
            </CCol>
            </CRow>
    
        </CCol>
        <MainlayoutBottom></MainlayoutBottom>
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
export default ({
    components: {
    MainlayoutBottom,
  },
    data() {
        return {

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToDate()
        {
            this.$router.push("ChooseDateBooking");
        }

    }
})
</script>
